module.exports = __webpack_public_path__ + "ipetbooking/admin/img/store-alt.6c4b892e.svg";